<template>
    <div>Page Not Authorized</div>
</template>

<script>
export default {
    name: 'NotAuthorize'
}
</script>